export const GET_PAYMENT_REQUEST = 'payment/getPaymentRequest';
export const CHECK_PAYMENT_REQUEST = 'payment/checkPaymentRequest';
export const GET_PAYMENT_NETWORKS_TOKENS = 'payment/getPaymentNetworksTokens';
export const ESTIMATE_PAYMENT = 'payment/estimatePayment';
export const CONFIRM_PAYMENT = 'payment/confirmPayment';
export const GET_PAYMENT_WALLETS = 'payment/wallets';
export const CANCEL_PAYMENT = 'payment/cancelPayment';

export const actionTypes = {
  GET_PAYMENT_REQUEST,
  GET_PAYMENT_NETWORKS_TOKENS,
  ESTIMATE_PAYMENT,
  CONFIRM_PAYMENT,
  GET_PAYMENT_WALLETS,
  CANCEL_PAYMENT,
  CHECK_PAYMENT_REQUEST,
};
